/* Cover My Plate · keeps design uploads under the upload service's ~1 MB request limit.
   Every builder posts {base64Image, filename} to .../api/upload-shopify-file. Busy designs (AI backgrounds, photos)
   make print and preview files bigger than the service accepts, and the request fails.
   This wraps fetch for that one endpoint. An over-limit file is first sent at FULL resolution (original bytes)
   to the Supabase function cmp-upload-print (orders/print-hq/...), and the caller gets back the same JSON shape
   the Vercel endpoint returns ({url, id:null}). Only if that fails (or the file is over 10 MB) does the old
   path run: JPEGs are re-encoded at lower quality (then scaled if still too big), PNGs are scaled down
   (transparency kept). The file's DPI tag is carried over and adjusted for any scaling, so print files still
   come out at the right physical size. Loaded from sections/cmp-seo.liquid. */
(function () {
  'use strict';
  if (window.__cmpUploadFit || !window.fetch) return;
  window.__cmpUploadFit = true;
  var LIMIT = 950000, nativeFetch = window.fetch;
  var FULL_URL = 'https://hdyurpmjhgionqalrqvb.supabase.co/functions/v1/cmp-upload-print', FULL_MAX = 10 * 1024 * 1024;
  var MIMES = { png: 'image/png', jpg: 'image/jpeg', jpeg: 'image/jpeg', webp: 'image/webp' };

  // Original bytes -> Supabase storage. Resolves to the Vercel-style {url, id:null} or rejects.
  function full(d, filename, sig) {
    var i = d.indexOf(','), m = /^data:([^;,]+)/.exec(d.slice(0, 64)), mime = m ? m[1].toLowerCase() : '';
    var b64 = d.slice(i + 1); // works for raw base64 too (i === -1)
    if (!mime) { var ext = (/\.([a-z0-9]+)$/i.exec(filename || '') || [])[1]; mime = MIMES[(ext || '').toLowerCase()] || ''; }
    if (mime === 'image/jpg') mime = 'image/jpeg';
    if (['image/png', 'image/jpeg', 'image/webp'].indexOf(mime) < 0) return Promise.reject(new Error('type ' + (mime || 'unknown')));
    var bin = atob(b64), len = bin.length;
    if (len > FULL_MAX) return Promise.reject(new Error('file is ' + len + ' bytes (max ' + FULL_MAX + ')'));
    var u8 = new Uint8Array(len);
    for (var n = 0; n < len; n++) u8[n] = bin.charCodeAt(n);
    var name = String(filename || ('print.' + mime.split('/')[1])).replace(/[^A-Za-z0-9._-]+/g, '-').slice(-120);
    var ctrl = window.AbortController ? new AbortController() : null, t = setTimeout(function () { ctrl && ctrl.abort(); }, 90000);
    return nativeFetch.call(window, FULL_URL + '?folder=print-hq&name=' + encodeURIComponent(name), {
      method: 'POST', headers: { 'Content-Type': mime }, body: new Blob([u8], { type: mime }), signal: sig || (ctrl ? ctrl.signal : undefined)
    }).then(function (r) {
      clearTimeout(t);
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok || !j || !j.url) throw new Error('HTTP ' + r.status + (j && j.error ? ' ' + j.error : ''));
        return { url: j.url, id: null };
      });
    }, function (e) { clearTimeout(t); throw e; });
  }

  function head(d) { // first ~300 bytes of the file
    var i = d.indexOf(','), s = atob(d.slice(i + 1, i + 1 + 400)), b = new Uint8Array(s.length);
    for (var n = 0; n < s.length; n++) b[n] = s.charCodeAt(n);
    return b;
  }
  function dpiOf(d) {
    try {
      var b = head(d);
      if (b[0] === 255 && b[1] === 216 && b[2] === 255 && b[3] === 224 && b[13] === 1) return (b[14] << 8) | b[15];
      if (b[0] === 137 && b[1] === 80) { // PNG: look for pHYs in the first chunks
        for (var i = 8; i < b.length - 20;) {
          var len = (b[i] << 24 | b[i + 1] << 16 | b[i + 2] << 8 | b[i + 3]) >>> 0, t = String.fromCharCode(b[i + 4], b[i + 5], b[i + 6], b[i + 7]);
          if (t === 'pHYs') { var ppm = (b[i + 8] << 24 | b[i + 9] << 16 | b[i + 10] << 8 | b[i + 11]) >>> 0; return b[i + 16] === 1 ? Math.round(ppm * 0.0254) : 0; }
          if (t === 'IDAT') break;
          i += 12 + len;
        }
      }
    } catch (e) {}
    return 0;
  }
  function load(src) {
    return new Promise(function (res, rej) { var im = new Image(); im.onload = function () { res(im); }; im.onerror = rej; im.src = src; });
  }
  function enc(im, s, type, q) {
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(im.naturalWidth * s)); c.height = Math.max(1, Math.round(im.naturalHeight * s));
    var x = c.getContext('2d');
    if (type === 'image/jpeg') { x.fillStyle = '#ffffff'; x.fillRect(0, 0, c.width, c.height); }
    x.imageSmoothingQuality = 'high';
    x.drawImage(im, 0, 0, c.width, c.height);
    return c.toDataURL(type, q);
  }
  function shrink(d) {
    var png = d.slice(0, 40).indexOf('image/png') > -1, dpi = dpiOf(d);
    return load(d).then(function (im) {
      var out = d, s = 1, qs = [0.9, 0.84, 0.78, 0.72, 0.66, 0.6];
      if (!png) {
        for (var n = 0; n < qs.length; n++) { out = enc(im, 1, 'image/jpeg', qs[n]); if (out.length < LIMIT) break; }
        while (out.length >= LIMIT && s > 0.3) { s *= 0.85; out = enc(im, s, 'image/jpeg', 0.8); }
      } else {
        while (out.length >= LIMIT && s > 0.25) { s *= 0.85; out = enc(im, s, 'image/png'); }
      }
      if (dpi && window.CXU && window.CXU.withDpi) out = window.CXU.withDpi(out, Math.max(1, Math.round(dpi * s)));
      return out;
    });
  }

  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/upload-shopify-file/.test(url) && init && typeof init.body === 'string' && init.body.length > LIMIT) {
        var j = JSON.parse(init.body);
        if (j && typeof j.base64Image === 'string' && j.base64Image.length >= LIMIT) {
          var self = this, args = arguments;
          var downscale = function () {
            return shrink(j.base64Image).then(function (d) {
              j.base64Image = d;
              var next = {}; for (var k in init) next[k] = init[k];
              next.body = JSON.stringify(j);
              return nativeFetch.call(window, input, next);
            }, function () { return nativeFetch.apply(self, args); });
          };
          var tried;
          try { tried = full(j.base64Image, j.filename, init.signal); } catch (e) { tried = Promise.reject(e); }
          return tried.then(function (out) {
            return new Response(JSON.stringify(out), { status: 200, headers: { 'Content-Type': 'application/json' } });
          }, function (e) {
            try { console.warn('[cmp-upload-fit] full-size upload failed, downscaling instead:', (e && e.message) || e); } catch (x) {}
            return downscale();
          });
        }
      }
    } catch (e) {}
    return nativeFetch.apply(this, arguments);
  };
  window.CMPUploadFit = { shrink: shrink, full: full, limit: LIMIT };
})();
